import { ManagePatientsTable } from '@/components/Templates/ManagePatients';

const ManagePatients = () => {
	return <ManagePatientsTable />;
};

export default ManagePatients;
